module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout', [_c('div', {
    staticClass: "container"
  }, [_c('search', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.community),
      expression: "community"
    }],
    attrs: {
      "auto-fixed": false,
      "placeholder": "请输入小区名(查询一次仅需1钢蹦)"
    },
    domProps: {
      "value": (_vm.community)
    },
    on: {
      "on-submit": _vm.submit,
      "input": function($event) {
        _vm.community = $event
      }
    }
  }), _vm._v(" "), _c('divider', [_vm._v("-")]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('confirm', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.show),
      expression: "show"
    }],
    attrs: {
      "title": _vm.show_title,
      "confirm-text": _vm.btn_ok,
      "cancel-text": _vm.btn_cancel
    },
    domProps: {
      "value": (_vm.show)
    },
    on: {
      "on-cancel": _vm.onCancel,
      "on-confirm": _vm.onConfirm,
      "input": function($event) {
        _vm.show = $event
      }
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.show_content))])]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.subtitleMsg))]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.coins >= 1) ? _c('div', _vm._l((_vm.lists), function(item) {
    return _c('div', {
      key: item,
      staticClass: "list-item"
    }, [_c('p', {
      staticClass: "p-padding"
    }), (_vm.pageType === '0') ? _c('div', [_c('router-link', {
      attrs: {
        "to": {
          path: '/test',
          query: {
            cm: item,
            type: _vm.reqType
          }
        }
      }
    }, [_vm._v("\n            " + _vm._s(item) + "\n            ")])], 1) : _c('div', [_c('router-link', {
      attrs: {
        "to": {
          path: '/test',
          query: {
            cm: item,
            type: _vm.reqType
          }
        }
      }
    }, [_vm._v("\n            " + _vm._s(item) + "\n            ")])], 1), _vm._v(" "), _c('p')])
  })) : _vm._e()], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.3.0@vue-loader/lib/template-compiler.js?id=data-v-e281eda4!./~/.1.0.35@vux-loader/src/template-loader.js!./~/.10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/HomeBody.vue
// module id = 295
// module chunks = 2